import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FNumberFieldMDP from "@/components/form/field/FNumberFieldMDP";
import FRangeSliderSPAMDP from "@/components/form/field/FRangeSliderSPAMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";


export default class TMOStimulatorFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  constructor({ taskRoot }: { taskRoot: any }) {
    super({
      myRefName: "tmoStimulatorFFormRef",
      disabled: taskRoot.taskDisabled,
    });
    this.taskRoot = taskRoot;

    this.addField(
      new FCurrencyFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "outstanding",
        label: "Outstanding Amount",
        mandatory: true,
        boundaryClass: "col-3",
        disabled: true,
      })
    )
      .addField(
        new FNumberFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "settlementPercentage",
          label: "Settlement Percentage",
          boundaryClass: "col-3",
          disabled: !this.taskRoot.editMode,
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "affordability",
          label: "Affordability",
          boundaryClass: "col-3",
          disabled: true,
        })
      )
      .addField(
        new FSelectDateFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "firstSPADraftDate",
          label: "First SPA Draft Date",
          // mandatory: true,
          boundaryClass: "col-3",
          pastDaysDisabled: true,
          disabled: true,
          condition: (!!this.taskRoot.tmoSimulatorFormInput?.selectedDraftDay && this.taskRoot.tmoSimulatorFormInput?.selectedDraftDay>=15)
        })
      )
      .addField(
        new FSelectFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "selectedDraftDay",
          label: "Payment Day",
          mandatory: true,
          boundaryClass: "col-3",
          disabled: !this.taskRoot.editMode,
          options:Array.from({length: 15}, (_, i) => i + 1),
          clearable: true,
          rules: "selected_draftday"
        })
      )

      .addField(
        new FRangeSliderSPAMDP({
          parentMDP: this.childMDP,
          mandatory: true,
          boundaryClass: "col-12",
          disabled: !this.taskRoot.editMode,
          // maxValue: this.taskRoot?.repaymentAmount || 500000,
          // minValue:(this.taskRoot?.repaymentAmount || 0)/90
          // ,
          dataSelectorKey: "tenure",
          affordability: this.taskRoot?.tmoSimulatorFormInput?.affordability,
          // tenure: this.taskRoot?.tenure,
          tenureApproval: this.taskRoot?.computedResult?.tenureApproval,
          outstanding: this.taskRoot.tmoSimulatorFormInput.outstanding,
          totalPercentage: this.taskRoot.totalPercentage
        })
      );
      // .addField(
      //   new FRangeSliderMDP({
      //     parentMDP: this.childMDP,
      //     mandatory: true,
      //     boundaryClass: "col-12",
      //     disabled: !this.taskRoot.editMode,
      //     maxValue: 90,
      //     minValue:1
      //   })
      // );
  }

  getMyRef(): any {
    return this.taskRoot.$refs[this.myRefName];
  }
}
